import { render } from "./CreaalLogo.vue?vue&type=template&id=c81e6482"
const script = {}

import "./CreaalLogo.vue?vue&type=style&index=0&id=c81e6482&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__